import { getAcademicYearAccess } from '@/api/academics';
import { queryKeys } from '@/lib/queryKeys';
import { useSchoolScopedQuery } from './useSchoolScopedQuery';

/** Roles change rarely: ask once per school and session-ish (half an hour). */
const ACCESS_STALE_TIME = 30 * 60 * 1000;

/**
 * The caller's rights over past academic years in the current school
 * (`GET api/academic-years/access`): editing a closed or ended year, and running the
 * rollover. Fabrica's roles decide them on the server; the UI never lists roles.
 * Pass `enabled: false` to hold the request back until it matters.
 */
export const useAcademicYearAccess = ({ enabled = true }: { enabled?: boolean } = {}) =>
  useSchoolScopedQuery(queryKeys.academics.yearAccessFor, getAcademicYearAccess, undefined, {
    enabled,
    staleTime: ACCESS_STALE_TIME,
  });
